import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { ISmevMessageResponse } from '../interfaces/ISmevMessageResponse';
import { ISmevMessageCreateRequest } from '../interfaces/ISmevMessageCreateRequest';
import { IRequestType } from '../interfaces/IRequestType';
import { IRequestTemplate } from '../interfaces/IRequestTemplate';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';

function isErpFromSystemType(systemType?: string): boolean | undefined {
  return systemType ? systemType.toLowerCase() === 'erp' : undefined;
}

export async function fetchSmevMessage(id: string, systemType?: string): Promise<ISmevMessageResponse> {
  const queryParams = new URLSearchParams();

  queryParams.append('id', id);

  const base = getServiceBaseURL(APIServiceEnum.BASE_SERVICE, isErpFromSystemType(systemType));

  return apiGet<ISmevMessageResponse>(`${base}/smev-message?${queryParams}`);
}

export async function fetchRequestTypes(): Promise<IRequestType[]> {
  const base = getServiceBaseURL(APIServiceEnum.LK_SERVICE);

  return apiGet<IRequestType[]>(`${base}/smev-message/request-type`);
}

export async function fetchRequestTemplates(): Promise<IRequestTemplate[]> {
  const base = getServiceBaseURL(APIServiceEnum.LK_SERVICE);

  return apiGet<IRequestTemplate[]>(`${base}/smev-message/request-template`);
}

export async function createSmevMessage(
  request: ISmevMessageCreateRequest,
  systemType?: string,
): Promise<ISmevMessageResponse> {
  const base = getServiceBaseURL(APIServiceEnum.BASE_SERVICE, isErpFromSystemType(systemType));

  return apiPost<ISmevMessageResponse>({
    url: `${base}/smev-message`,
    body: request,
  });
}
